import urlParameter from '@hc-frontend/shared-assets/src/js/utils/url/urlParameter'
import executeWhenFinishToRender from 'core/renders/executeWhenFinishToRender'
import removeClassStartingWith from 'core/DOM/removeClassStartingWith'
import isSalesCenterAgent from 'utils/pivot/agent/isSalesCenterAgent'
import getAgentLoggedId from 'utils/pivot/agent/getAgentLoggedId'
import updateStorages from 'core/controllerPlans/updateStorages'
import updateMultiCarrierEligibility from 'core/controllerPlans/update-multi-carrier-eligibility'
import returningUserBar from 'pug/mixins/returningUserBar'
import appStateUpdated from 'utils/appStateUpdated'
import toggleClass from 'utils/DOM/toggleClass'
import store from 'utils/store/withMiddleware'
import { propAccessor, stringToDate, getTodayDate } from '@hc-frontend/utils'
import agentStore from 'utils/store/simple'
import getById from 'utils/DOM/getById'
import initPage from 'core/initPage'
import storage from 'proxy-storage'
import appLoader from './appLoader'
import 'bootstrap/js/src/modal'
import config from './config'
import { enableMultiCarrierPlans } from 'utils/experiments'

import './styles.scss'
import querySelectorAll from 'utils/DOM/querySelectorAll'
import forEach from 'utils/DOM/forEach'
import attachCustomDataToRaygun from 'utils/raygun'
import sessionHandler from 'core/controllers/sessionHandler'

const contentBlock = getById('census-content')
const agentIdUrl = urlParameter('agent_id')
const hcStorage = storage.getItem('hc') || {}
const agent_id = getAgentLoggedId() || agentIdUrl || hcStorage.agent_id || 2010000

hcStorage.agent_id = agent_id

const promiseInitPage = isSalesCenterAgent(agent_id).then(isSalesCenter => {
  return initPage({
    placement: config.placement,
    tags: ['Census'],
    clearStorage: (isSalesCenter && !urlParameter('backTo')) || false
  })
    .then(updateStorages)
    .then(updateMultiCarrierEligibility)
    .then(({ hcStorage }: PlainObject) => {
      store.registry([appStateUpdated])
      store.update({})
      return {
        hcStorage,
        agentInformation: agentStore.getState()
      }
    })
})

function addWhyItemTooltip() {
  const whyItemExist = querySelectorAll('.why-item').length > 0

  if (!whyItemExist) {
    forEach('.c-Form__step1 .c-Form__step-title', node => {
      node.innerHTML +=
        ' <button class="hc-tooltip-holder why-item help d-inline-block" type="button" tabindex="0" data-toggle="tooltip" title="" data-original-title="Insurance companies need a little demographic information about you to determine rates. The monthly premium cost of a plan can vary based on your location and age. You’ll want to provide accurate information to get the best rate.">Why?</button>'
    })
  }
}

const utmSource =
  urlParameter('utm_source') || propAccessor(storage.getItem('hc'), 'utm.utm_source', '')

function initCensusApp(censusApp) {
  return promiseInitPage.then(initData => {
    // Setup GTM and add userId to dataLayer
    // window.dataLayerPushVariable({
    //   user_id: hcStorage.healthcareUserId
    // })
    const MULTI_CARRIER_ELIGIBILITY = store.getState().eligibilityBool
    const MULTI_CARRIER_ENABLED = enableMultiCarrierPlans()
    contentBlock.innerHTML = censusApp.default.render({
      MULTI_CARRIER_ENABLED,
      MULTI_CARRIER_ELIGIBILITY
    })
    removeClassStartingWith(contentBlock, 'census--')
    toggleClass(contentBlock, `census--${censusApp.default.name}`, true)

    censusApp.default.init(initData)
    returningUserBar(initData.hcStorage)
    const { healthcareSession, healthcareUserId } = initData.hcStorage
    const dataToTrack = {
      healthcareSession: healthcareSession,
      healthcareUserId: healthcareUserId
    }

    attachCustomDataToRaygun(dataToTrack)
    executeWhenFinishToRender(initData.hcStorage)
    addWhyItemTooltip()
  })
}

function updateMessageGapPage() {
  // TODO: remove this after January 31, 2021
  const today = getTodayDate()
  const limitOEP = stringToDate('12/15/2020')
  const generalLimitOEP = stringToDate('01/31/2021')
  const todayTime = today.getTime()
  const oepClass =
    todayTime > generalLimitOEP.getTime()
      ? 'general-limit-oep'
      : todayTime > limitOEP.getTime()
      ? 'limit-oep'
      : ''

  if (oepClass) {
    toggleClass(document.body, oepClass, true)
  }
}

const saveSession = sessionHandler({
  useState: true,
  save: true
})

appLoader(utmSource).then(initCensusApp).then(saveSession).then(updateMessageGapPage)
